<template>
  <div class="verify-otp-email">
    <Message v-show="message.fieldName==='resendOTP'" :message="message" />
    <img
      class="verify-otp-email__icon"
      src="../../static/images/enter-otp-graphic.svg"
      alt="Enter Email OTP"
    />
    <h1 class="verify-otp-email__heading" id="email-text">
      Please enter the OTP sent to your email id
      <br />
      {{userEmail}}
    </h1>
    <form
      @submit.prevent="submitOTPEmail"
      class="verify-otp-email__form"
      novalidate
      autocomplete="off"
    >
      <div class="verify-otp-email__form__otp" id="otp">
        <input
          class="verify-otp-email__form__otp__email-field"
          type="tel"
          size="1"
          name="0"
          v-focus
          minlength="1"
          maxlength="1"
          pattern="[0-9]"
          required
          v-model="otp[0]"
          v-numericOnly
        />
        <input
          class="verify-otp-email__form__otp__email-field"
          type="tel"
          size="1"
          name="1"
          minlength="1"
          maxlength="1"
          pattern="[0-9]"
          required
          v-model="otp[1]"
          v-numericOnly
        />
        <input
          class="verify-otp-email__form__otp__email-field"
          type="tel"
          size="1"
          name="2"
          minlength="1"
          maxlength="1"
          pattern="[0-9]"
          required
          v-model="otp[2]"
          v-numericOnly
        />
        <input
          class="verify-otp-email__form__otp__email-field"
          type="tel"
          size="1"
          name="3"
          minlength="1"
          maxlength="1"
          pattern="[0-9]"
          required
          v-model="otp[3]"
          v-numericOnly
        />
        <input
          class="verify-otp-email__form__otp__email-field"
          type="tel"
          size="1"
          name="4"
          minlength="1"
          maxlength="1"
          pattern="[0-9]"
          required
          v-model="otp[4]"
          v-numericOnly
        />
        <input
          class="verify-otp-email__form__otp__email-field"
          type="tel"
          size="1"
          name="5"
          minlength="1"
          maxlength="1"
          pattern="[0-9]"
          required
          v-model="otp[5]"
          v-numericOnly
        />
        <Message v-show="message.fieldName==='otp'" :message="message" />
      </div>
      <label
        for
        class="verify-otp-email__form__label--alternate verify-otp-email__form__label--alternate--text-center"
      >
        <template v-if="timer===0">
          Didn't receive OTP?
          <button
            id="resend-button"
            class="verify-otp-email__form__label--alternate__link"
            type="button"
            @click="resendEmailOTP"
          >Resend</button>
        </template>
        <template v-else>
          <span>You can resend in</span>
          <span class="verify-otp-email__form__label--alternate--timer-number">{{timer}}s</span>
        </template>
      </label>
      <template v-if="message && message.showModal">
        <Overlay @on-click="unsetErrors" />
        <ConfirmationModal :message="message">
          <template v-slot:close-button>
            <button class="close-button" type="button" @click="unsetErrors">
              <img src="../../static/images/cross.svg" alt="Close Button" />
            </button>
          </template>
          <ActionButton
            v-slot:default
            v-for="(action,index) in message.actions"
            :key="index"
            @click="action.method"
            :title="action.title"
            :className="action.isPrimary?'':'action-button--alternate'"
            type="button"
          />
        </ConfirmationModal>
      </template>

      <ActionButton title="Continue" />
    </form>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ActionButton from "../components/ActionButton";
import Message from "../components/SignupInfoMessage";
import Overlay from "../components/Overlay";
import ConfirmationModal from "../components/ConfirmationModal";
export default {
  name: "Sign-Up-Verify-OTP-Email",
  data() {
    return {
      otp: [],
      params: { otp: undefined },
      fieldName: 0,
      message: {
        value: undefined,
        type: undefined,
        className: undefined,
        fieldName: undefined,
        actions: undefined,
        showModal: undefined
      },
      timer: 30,
      timerInterval: undefined
    };
  },
  components: { ActionButton, Message, Overlay, ConfirmationModal },
  computed: {
    ...mapGetters(["signupStatus", "userEmail", "dmiEligible"])
  },
  mounted() {
    this.timerInterval = setInterval(() => {
      if (this.timer > 0) {
        this.timer -= 1;
      }
    }, 1000);
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "SCREEN",
      propertyName: "SCREEN_NAME",
      propertyValue: "VERIFY_EMAIL"
    });
    if (
      this.$router.matcher.match("", "", "redirectedFrom").name ===
      "Personal Details"
    ) {
      this.$store.dispatch("storeMixpanelEvent", {
        eventName: "EMAIL_OTP_SCREEN",
        propertyName: "PREVIOUS_SCREEN",
        propertyValue: "PERSONAL_DETAILS"
      });
    } else if (
      this.$router.matcher.match("", "", "redirectedFrom").name ===
      "Employment Details"
    ) {
      this.$store.dispatch("storeMixpanelEvent", {
        eventName: "EMAIL_OTP_SCREEN",
        propertyName: "PREVIOUS_SCREEN",
        propertyValue: "EMPLOYMENT_DETAILS"
      });
    } else if (
      this.$router.matcher.match("", "", "redirectedFrom").name === "Verify OTP"
    ) {
      this.$store.dispatch("storeMixpanelEvent", {
        eventName: "EMAIL_OTP_SCREEN",
        propertyName: "PREVIOUS_SCREEN",
        propertyValue: "VERIFY_EMAIL"
      });
    } else {
      this.$store.dispatch("storeMixpanelEvent", {
        eventName: "EMAIL_OTP_SCREEN",
        propertyName: "PREVIOUS_SCREEN",
        propertyValue: "UNKNOWN"
      });
    }
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "PERSONAL_DETAILS_ENTERED",
      propertyName: "DMI_ELIGIBLE",
      propertyValue: this.dmiEligible ? "YES" : "NO"
    });
  },
  created() {
    history.pushState(null, null, document.URL);
    window.addEventListener("popstate", () => {
      history.pushState(null, null, document.URL);
      this.message = {
        type: "error",
        fieldName: "email",
        value: `Are you sure you want to skip the ePayLater registration?`,
        showModal: true,
        actions: [
          {
            title: "Yes",
            method: () => this.$router.push({ name: "Login" }),
            isPrimary: false
          },
          {
            title: "No",
            method: () => this.unsetErrors(),
            isPrimary: true
          }
        ]
      };
    });
  },
  watch: {
    otp(val) {
      const currentFieldName = parseInt(document.activeElement.name);
      if (this.fieldName >= currentFieldName && currentFieldName !== 0) {
        document.activeElement.previousElementSibling.focus();
      } else if (this.fieldName <= currentFieldName && currentFieldName !== 5) {
        document.activeElement.nextElementSibling.focus();
      }
      this.params.otp = this.otp.join("");
      this.fieldName = currentFieldName;
    }
  },
  methods: {
    submitOTPEmail() {
      this.$store
        .dispatch("generateRecaptcha", { action: "mobile" })
        .then(token => {
          this.params.recaptcha = token;
          this.$store
            .dispatch("verify_email_otp", this.params)
            .then(response => {
              window.clearInterval(this.timerInterval);
              this.$router.push({ name: "Loading" });
            })
            .catch(err => {
              if (err.status === 401) {
                this.$router.push({ name: "Signup" });
              } else {
                this.message = {
                  type: "warning",
                  className: "message--error",
                  fieldName: "generic",
                  value: err.data.message,
                  showModal: true,
                  actions: [
                    {
                      title: "Ok",
                      method: () => this.unsetErrors(),
                      isPrimary: true
                    }
                  ]
                };
              }
            });
        });
    },
    resendEmailOTP() {
      this.$store
        .dispatch("emailResend")
        .then(response => {
          this.timer = 30;
          this.message = {
            type: "success",
            className: "message--success",
            fieldName: "resendOTP",
            value: "OTP has been resent to your email."
          };
        })
        .catch(err => {
          if (err.status === 401) {
            this.$router.push({ name: "Signup" });
          } else {
            this.message = {
              type: "warning",
              className: "message--error",
              fieldName: "generic",
              value: err.data.message,
              showModal: true,
              actions: [
                {
                  title: "Ok",
                  method: () => this.unsetErrors(),
                  isPrimary: true
                }
              ]
            };
          }
        });
    },
    unsetErrors() {
      this.message = {};
    }
  }
};
</script>
<style lang="scss" scoped>
.verify-otp-email {
  max-width: 30rem;
  justify-self: center;
  text-align: center;
  &__icon {
    margin-top: 2rem;
  }
  &__heading {
    font-size: 1.6rem;
    text-align: center;
    color: var(--gray-2);
    margin-top: 3rem;
    margin-bottom: 4rem;
    @media only screen and (min-width: 640px) {
      font-size: 2.2rem;
    }
  }
  &__form {
    &__otp {
      margin-bottom: 3.4rem;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      &__email-field {
        border: none;
        border-bottom: solid 0.06rem var(--gray-4);
        margin: 0.75rem;
        text-align: center;
        font-size: 1.6rem;
        width: 3rem;
        @media only screen and (min-width: 640px) {
          font-size: 1.8rem;
        }
        &:focus {
          border-bottom: 0.1rem solid var(--primary-color);
          outline: none;
        }
      }
    }
    &__label {
      &--alternate {
        font-size: 1.4rem;
        color: var(--gray-3);
        margin-bottom: 1.6rem;
        align-items: center;
        font-weight: 300;
        display: grid;
        grid-template-columns: auto 1fr;
        grid-template-rows: 1fr 1fr;
        grid-column-gap: 0px;
        grid-row-gap: 0px;
        &--text-center {
          display: block;
          text-align: center;
        }
        &--timer-number {
          color: var(--primary-color);
          font-size: 2rem;
          width: 3rem;
          display: inline-block;
          text-align: center;
        }
        &__link {
          color: var(--primary-color);
          text-decoration: none;
          background: transparent;
          box-shadow: none;
          border: none;
          cursor: pointer;
          font-size: 1.4rem;
          &:disabled {
            cursor: default;
            color: var(--gray-3);
          }
        }
      }
    }
  }
}
.message {
  width: 100%;
  justify-content: center;
}
.close-button {
  background: transparent;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/SignupVerifyOTPEmail.vue